import script from "./GuestSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestSetup.vue?vue&type=script&setup=true&lang=js"

import "./GuestSetup.vue?vue&type=style&index=0&id=45ee6e6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ee6e6a"]])

export default __exports__